import { createContext, useState } from "react";

export const TextContext = createContext();

export const TextProvider = ({ children }) => {
  const [sharedText, setSharedText] = useState("متن اولیه");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedClassroomId, setSelectedClassroomId] = useState(null);

  return (
    <TextContext.Provider value={{ sharedText, setSharedText, selectedDate, setSelectedDate, selectedClassroomId, setSelectedClassroomId }}>
      {children}
    </TextContext.Provider>
  );
};
